module.exports = __webpack_public_path__ + "static/bg-wave-8091d99ac3656f9876d3d820b76cba3e.png";